import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {workLocationsTableReady,rowsPerPageState,searchTextState,paginationState,workLocationsIdForAction} from '../redux/workLocations'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/workLocationsTable.css'


import * as Helpers from '../../../common/helpers'




function filterUnwantedData(workLocationsData) {
    let array = []
    if (workLocationsData && workLocationsData.data && workLocationsData.data.list) {
        array = workLocationsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.name = lineData.name ? lineData.name : ""
            newLineData.type = lineData.type ? lineData.type : ""
            newLineData.address = lineData.address ? lineData.address : ""
            newLineData.city_name = lineData.city && lineData.city.name ? lineData.city.name : ""

            newArray[i] = newLineData
        }
    }
    return newArray
}


class WorkLocationsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            workLocationsData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(workLocationsTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.WORKLOCATIONS_TABLE))

        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getWorkLocationsData()
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getWorkLocationsData = () => {
        apiService.getWorkLocationsData()
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.workLocations && this.props.workLocations.previousPaginationValue) {
                            pageNo = this.props.workLocations.previousPaginationValue
                        }
                        this.setState({
                            workLocationsData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(workLocationsTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(workLocationsTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.workLocations && this.props.workLocations.previousRowsPerPageValue) {
            value = this.props.workLocations.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">



{(() =>{

    if(Helpers.checkPrivileges("/dashboard/workLocations/addEdit",this.props.user)){
        return(
                    
                   
                   <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.dispatch(workLocationsIdForAction(null))
                                this.props.history.push("/dashboard/workLocations/addEdit")
                            }}>
                            Add
                        </button>
                    </div>
            )
        }
})()}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
   
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.workLocationsData.length>=(this.props.workLocations.previousPaginationValue*this.props.workLocations.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.workLocations.previousPaginationValue*this.props.workLocations.previousRowsPerPageValue)-this.props.workLocations.previousRowsPerPageValue+1} to {this.props.workLocations.previousPaginationValue*this.props.workLocations.previousRowsPerPageValue} of {this.state.workLocationsData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.workLocations.previousPaginationValue*this.props.workLocations.previousRowsPerPageValue)-this.props.workLocations.previousRowsPerPageValue+1} to {this.state.workLocationsData.length} of {this.state.workLocationsData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredBrandList = () => {
       
        this.props.dispatch(workLocationsTableReady(false))
        this.resetSearchAndPagination()
        this.getWorkLocationsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getWorkLocationsData()
        this.props.dispatch(workLocationsTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }




    actionButtonsCreator = (cell, row) => {
        let editPrivilege =""


    if(Helpers.checkPrivileges("/dashboard/workLocations/addEdit",this.props.user)){
        
            editPrivilege=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editPrivilege(row)
                }}>
                Edit
            </button>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editPrivilege}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.workLocations && this.props.workLocations.previousPaginationValue
            && this.props.workLocations.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editPrivilege = (row) => {
        if (row && row.id) {
            this.props.dispatch(workLocationsIdForAction(row.id))
            this.props.history.push("/dashboard/workLocations/addEdit")
        } else {
            this.dialog.show({
                title: "Privilege Identification number not found",
                body: 'Privilege id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.workLocations && this.props.workLocations.previousRowsPerPageValue) {
            sizeperPage = this.props.workLocations.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="workLocations-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.workLocationsData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                     >

                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                    <TableHeaderColumn
                        dataField="name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="type"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Type
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="city_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       City
                    </TableHeaderColumn>
                    
                    <TableHeaderColumn
                        dataField="address"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Address
                    </TableHeaderColumn>
                    
                    
                     <TableHeaderColumn
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        workLocations: state.workLocations
    }
}

export default connect(mapStateToProps)(withRouter(WorkLocationsTable))


// WEBPACK FOOTER //
// ./src/modules/Work Locations/Components/WorkLocationsTable.js